// Resolves the 5-digit ZIP registered as the `zip_code` Mixpanel super
// property: the voter's saved address, so reports can segment by where voters
// are. It follows the saved address, not the view — national view keeps it,
// since the address stays saved there. Kept identical to mobile's
// src/utils/analyticsZip.ts.

interface AddressComponentLike {
  types?: string[];
  shortText?: string;
  longText?: string;
  shortName?: string;
  longName?: string;
  short_name?: string;
  long_name?: string;
}

const ZIP5 = /^(\d{5})/;

export const normalizeZip = (value: string | null | undefined): string | null => {
  const match = ZIP5.exec(String(value ?? '').trim());
  return match ? match[1] : null;
};

export const zipFromAddressComponents = (components: unknown): string | null => {
  // Persisted guest addresses are restored from storage unvalidated, so this
  // may not be an array at runtime.
  if (!Array.isArray(components)) return null;
  const postal = (components as AddressComponentLike[]).find(
    (c) => Array.isArray(c?.types) && c.types.includes('postal_code')
  );
  if (!postal) return null;
  return normalizeZip(
    postal.shortText || postal.shortName || postal.short_name || postal.longText || postal.long_name
  );
};

/**
 * Signed-in users report their profile ZIP; guests report the ZIP of the
 * address they entered. Null when neither is known (e.g. national view).
 */
export const resolveAnalyticsZip = ({
  isAuthenticated,
  userZip,
  guestAddressComponents,
}: {
  isAuthenticated: boolean;
  userZip?: string | null;
  guestAddressComponents?: unknown[];
}): string | null =>
  isAuthenticated ? normalizeZip(userZip) : zipFromAddressComponents(guestAddressComponents);
